import PropTypes from "prop-types";
import React from "react";
import { Redirect } from "react-router";
import MainPage from "../components/MainPage.react";
import JobStore from "../stores/JobStore";
import EnabledFeaturesStore from "../stores/EnabledFeaturesStore";
import CurrentRoleStore from "../stores/CurrentRoleStore";
import ProfileStore from "../stores/ProfileStore";
import JobActions from "../actions/JobActions";
import JobTable from "../components/JobTable.react";
import AppSelector from "../components/AppSelector.react";

function getState() {
  return {
    jobs: JobStore.getAllChrono(),
    enabledFeatures: EnabledFeaturesStore.getState(),
    userName: ProfileStore.getGivenName(),
  };
}

class Overview extends React.Component {
  constructor(props) {
    super(props);
    this.state = getState();
    this._onChange = this._onChange.bind(this);
    this.selectJob = this.selectJob.bind(this);
  }

  componentDidMount() {
    this.enabledFeaturesSubscription = EnabledFeaturesStore.addListener(
      this._onChange
    );
    this.jobStoreSubscription = JobStore.addListener(this._onChange);
    this.profileSubscription = ProfileStore.addListener(this._onChange);
    JobActions.debouncedLoadAllJobs();
  }

  componentWillUnmount() {
    this.enabledFeaturesSubscription.remove();
    this.jobStoreSubscription.remove();
    this.profileSubscription.remove();
  }

  _onChange() {
    this.setState(getState());
  }

  selectJob(job) {
    const { router } = this.context;
    if (job.id) {
      router.push(`/jobs/${job.id}`);
    } else {
      router.push("/jobs");
    }
  }

  render() {
    if (CurrentRoleStore.getState() && CurrentRoleStore.isContentViewer()) {
      const { router } = this.context;
      router.push("/content");
    }
    return (
      <MainPage className="overview">
        <h3>Apps</h3>
        <AppSelector enabledFeatures={this.state.enabledFeatures} />
        {this.state.enabledFeatures.jobStatus && [
          <h3 key="header">Jobs</h3>,
          <JobTable
            key="table"
            jobs={this.state.jobs}
            onSelect={this.selectJob}
          />,
        ]}
      </MainPage>
    );
  }
}

Overview.contextTypes = {
  router: PropTypes.object,
};

export default Overview;
